export default function OwnerStory() {
  const achievements = [
    { year: '2008', event: 'プロサーファーデビュー' },
    { year: '2012', event: 'ワールドツアー参戦' },
    { year: '2015', event: 'アジアチャンピオン獲得' },
    { year: '2018', event: '現役引退' },
    { year: '2020', event: 'WAVE RIDER オープン' }
  ];

  const surfSpots = [
    { name: 'ハワイ', icon: 'ri-sun-line' },
    { name: 'バリ', icon: 'ri-palm-tree-line' },
    { name: 'オーストラリア', icon: 'ri-ship-line' },
    { name: 'カリフォルニア', icon: 'ri-surfing-line' },
    { name: '湘南', icon: 'ri-home-heart-line' }
  ];

  return (
    <section id="owner" className="py-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            From Pro Surfer to Seaside Owner
          </h3>
          <div className="w-24 h-1 bg-blue-500 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div 
            className="h-96 lg:h-[600px] bg-cover bg-center rounded-2xl shadow-2xl"
            style={{
              backgroundImage: 'url(https://public.readdy.ai/ai/img_res/62cccad489bb0756a5607c11a1efea8a.jpg)'
            }}
          ></div>

          <div>
            <h4 className="text-3xl font-bold text-gray-900 mb-6">
              オーナー Kenji Tanaka
            </h4>
            <p className="text-gray-600 leading-relaxed mb-6">
              10年以上にわたりプロサーファーとして世界中の海を旅してきました。ハワイ、バリ、オーストラリア、カリフォルニア...それぞれの場所で出会った人々、文化、そして食が、私の人生を豊かにしてくれました。
            </p>
            <p className="text-gray-600 leading-relaxed mb-6">
              現役引退後、「次世代に美しい海を残したい」という想いから、このカフェを開業しました。サーフィンを通じて学んだ自然への敬意、世界中で味わった美味しい料理、そして地元湘南への愛情。それらすべてをこの場所に込めています。
            </p>
            <p className="text-gray-600 leading-relaxed mb-8">
              WAVE RIDERは、ただのカフェではありません。海を愛するすべての人が集まり、つながり、そして未来について考える場所です。皆さんのお越しを心よりお待ちしています。
            </p>

            <div className="bg-white rounded-xl p-6 shadow-lg">
              <h5 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                <i className="ri-map-pin-line text-blue-600 mr-2"></i>
                世界のサーフスポット
              </h5>
              <div className="flex flex-wrap gap-3">
                {surfSpots.map((spot, index) => (
                  <div
                    key={index}
                    className="flex items-center bg-blue-50 px-4 py-2 rounded-full"
                  >
                    <i className={`${spot.icon} text-blue-600 mr-2`}></i>
                    <span className="text-gray-700 font-medium">{spot.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Timeline */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <h4 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            キャリアハイライト
          </h4>
          <div className="relative">
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-blue-200"></div>
            <div className="space-y-8">
              {achievements.map((achievement, index) => (
                <div
                  key={index}
                  className={`flex items-center ${
                    index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'
                  }`}
                >
                  <div className={`w-1/2 ${index % 2 === 0 ? 'pr-8 text-right' : 'pl-8 text-left'}`}>
                    <div className="bg-blue-50 rounded-lg p-4 inline-block">
                      <div className="text-2xl font-bold text-blue-600 mb-1">
                        {achievement.year}
                      </div>
                      <div className="text-gray-700 font-medium">
                        {achievement.event}
                      </div>
                    </div>
                  </div>
                  <div className="w-4 h-4 bg-blue-600 rounded-full border-4 border-white shadow-lg z-10"></div>
                  <div className="w-1/2"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}